// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"cm-z","badgeLink":"dm-z","category":"em-z"};